// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var UserForm$ReactHooksTemplate = require("./UserForm.res.js");

function reducer(param, action) {
  if (typeof action !== "object") {
    return "InvalidUser";
  } else {
    return {
            TAG: "Available",
            _0: action._0
          };
  }
}

function fetchUser(id) {
  var url = "/api/v1/users/" + id;
  return Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                return Json_decode.field("user", User$ReactHooksTemplate.decode, param);
              }));
}

function UserEdit(props) {
  var id = props.id;
  var match = React.useReducer(reducer, "FetchingUser");
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (user) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchedUser",
                                  _0: user
                                }));
                }), fetchUser(id));
        }), []);
  if (typeof state !== "object") {
    if (state === "FetchingUser") {
      return JsxRuntime.jsx("p", {
                  children: "Loading user"
                });
    } else {
      return JsxRuntime.jsx("p", {
                  children: "User not found"
                });
    }
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(UserForm$ReactHooksTemplate.make, {
                      user: state._0
                    })
              });
  }
}

var make = UserEdit;

exports.reducer = reducer;
exports.fetchUser = fetchUser;
exports.make = make;
/* react Not a pure module */
